import commonMixin from '@/mixin/common'
import {addressList, addressDefault} from '@/api/server/address'
export default {
  name: 'UserAddressIndexPage',
  mixins: [commonMixin],
  data () {
    return {
      dialogAddrVisible: false,
      valueArea: null,
      form: {
          name: null,
          tel: null,
          province: null,
          city: null,
          region: null,
          province_code: null,
          city_code: null,
          region_code: null,
          address: null,
          is_default: 0,
          _id: 0,
      },
      list: [],
      total: null,
      isDefault: 0,
    }
  },
  components: {
  },
  methods: {
    onSetDefault (e) {
      let id = e.id
      let is_default = e.isDefault ? 1 : 0
      let query = {
        id: id,
        is_default: is_default,
      }
      addressDefault(query).then( (res) => {
        if (res.code === 200) {
          let list = res.data
          this._resetList(list)
        } else {
            this.warning(res.message)
        }
      })
    },
    onEdit (item) {
        if (item && item.id) {
            this.$router.push({name: 'user-address-edit', query: {id: item.id}})
        }
    },
    onAdd () {
        this._resetAddress()
        this.$router.push({name: 'user-address-edit'})
    },
    _resetAddress () {
        this._id = 0
        this.valueArea = null
        this.form = {
            name: null,
            tel: null,
            province: null,
            city: null,
            region: null,
            province_code: null,
            city_code: null,
            region_code: null,
            address: null,
            is_default: 0
        }
    },
    handleChangeCity (value) {
        // console.log('value', value)
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    _getList () {
        addressList().then( (res) => {
            if (res.code === 200) {
                let list = res.data
                this._resetList(list)
            } else {
                this.warning(res.message)
            }
        })
    },
    _resetList (list) {
      let listNew = list.map(function(item) {
          let newItem = item
          newItem['isDefault'] = item['isDefault'] ? true: false
          return newItem
      })
      this.list = listNew
    },
    reset () {
        this.list = []
        this.total = []
        this.dialogAddrVisible = false
        this._getList()
    },
    handleRoute (route) {
        if (route.name === 'user-address') {
            this.reset()
        }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}